import { render, staticRenderFns } from "./Sphere.vue?vue&type=template&id=94fc26ca"
import script from "./Sphere.vue?vue&type=script&lang=js"
export * from "./Sphere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports